import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTicketGroupStore = defineStore('ticket-group', () => {
  const groups = ref({ items: [], _meta: null })

  /**
   * Name of the ticket group that already owns `accountId`, if any.
   *
   * @param {string} accountId
   * @param {string|null|undefined} [excludeGroupId]
   * @returns {string}
   */
  function getAccountOwner(accountId, excludeGroupId = null) {
    if (!accountId) return ''
    const key = String(accountId)
    const exclude = excludeGroupId != null ? String(excludeGroupId) : ''
    const owner = groups.value.items.find((group) => {
      if (String(group._id) === exclude) return false
      return (group.accounts ?? []).some((account) => {
        const id = typeof account === 'object' ? account._id : account
        return String(id) === key
      })
    })
    return owner?.name ?? ''
  }

  const hydrate = {
    groups(data) {
      groups.value = data
    },
  }

  function reset() {
    groups.value = { items: [], _meta: null }
  }

  return {
    groups,
    hydrate,
    reset,
    getAccountOwner,
  }
})
